import axios from "axios";

const API_URL = "/audit-logs";

/**
 * Fetch paginated + filtered audit logs.
 */
export const getAuditLogs = async (params = {}) => {
  const response = await axios.get(API_URL, { params });
  return response.data;
};

/**
 * Fetch all unique module names for the filter dropdown.
 */
export const getAuditModules = async () => {
  const response = await axios.get(`${API_URL}/modules`);
  return response.data;
};

/**
 * Fetch a single audit log entry by ID.
 */
export const getAuditLogById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};
